export { useCoupon } from '@src/features/coupons/hooks/useCoupon';
export { default as CartCouponArea } from '@src/features/coupons/legacy/CartCouponArea';
export { CouponErrorEnum, isCouponErrorType, toCouponErrorKeys } from '@src/features/coupons/core/couponErrors';
export type { CouponErrorsType } from '@src/features/coupons/core/couponErrors';
